import { render, staticRenderFns } from "./user-req-list.html?vue&type=template&id=60e4c1d0&scoped=true&"
import script from "./user-req-list.js?vue&type=script&lang=js&"
export * from "./user-req-list.js?vue&type=script&lang=js&"
import style0 from "./user-req-list.scss?vue&type=style&index=0&id=60e4c1d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e4c1d0",
  null
  
)

export default component.exports